module.exports = __webpack_public_path__ + "files/SPIADI2023 - Rapport National CleanHand PROX - juin 2024.627e5bc372059bddc06f175631e04fba.pdf";